import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cog.icon",
  "use": "cog.icon-usage",
  "viewBox": "-10246.919 -16392 25.29 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-10246.919 -16392 25.29 26\" id=\"cog.icon\"><path d=\"M24.578,16.274A10.13,10.13,0,0,0,24.669,15a10.131,10.131,0,0,0-.091-1.274l2.743-2.145a.656.656,0,0,0,.156-.832l-2.6-4.5a.653.653,0,0,0-.793-.286l-3.237,1.3a9.5,9.5,0,0,0-2.2-1.274l-.494-3.445A.634.634,0,0,0,17.519,2h-5.2a.634.634,0,0,0-.637.546l-.494,3.445a9.988,9.988,0,0,0-2.2,1.274l-3.237-1.3a.634.634,0,0,0-.793.286l-2.6,4.5a.641.641,0,0,0,.156.832L5.26,13.726A10.31,10.31,0,0,0,5.169,15a10.31,10.31,0,0,0,.091,1.274L2.517,18.419a.656.656,0,0,0-.156.832l2.6,4.5a.653.653,0,0,0,.793.286l3.237-1.3a9.5,9.5,0,0,0,2.2,1.274l.494,3.445a.634.634,0,0,0,.637.546h5.2a.634.634,0,0,0,.637-.546l.494-3.445a9.988,9.988,0,0,0,2.2-1.274l3.237,1.3a.634.634,0,0,0,.793-.286l2.6-4.5a.656.656,0,0,0-.156-.832ZM14.919,19.55A4.55,4.55,0,1,1,19.469,15,4.555,4.555,0,0,1,14.919,19.55Z\" transform=\"translate(-10249.189 -16394)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cog.icon.svg
// module id = 6syw
// module chunks = 13